<footer class="site-footer">
    <div class="container">
        <div class="row">
            <div>
                <div id="text-2" class="footer-widget">
                    <div class="textwidget">
                        <div style="display: table; width: 100%;">

                            <figure
                                style="display: table-cell; padding: 0 2px; text-align: center; vertical-align: middle;">
                                <a href="https://www.auva.at/" target="_blank"
                                   title="Allgemeine Unfallversicherungsanstalt (AUVA)" rel="noopener">
                                    <img
                                        ngSrc="assets/images/small_auva.jpg"
                                        alt="Allgemeine Unfallversicherungsanstalt (AUVA)" height="46" width="78">
                                </a>
                            </figure>

                            <figure
                                style="display: table-cell; padding: 0 2px; text-align: center; vertical-align: middle;">
                                <a href="https://www.bvaeb.sv.at/" target="_blank"
                                   title="Versicherungsanstalt öffentlich Bediensteter, Eisenbahn und Bergbau(BVA)"
                                   rel="noopener">
                                    <img
                                        ngSrc="assets/images/bvaeb_logo.png"
                                        alt="Versicherungsanstalt öffentlich Bediensteter, Eisenbahn und Bergbau(BVA)"
                                        height="50" width="104">
                                </a>
                            </figure>

                            <figure
                                style="display: table-cell; padding: 0 2px; text-align: center; vertical-align: middle;">
                                <a href="https://www.pensionsversicherung.at/" target="_blank"
                                   title="Pensionsversicherungsanstalt (PVA)" rel="noopener">
                                    <img
                                        ngSrc="assets/images/small_pva.jpg"
                                        alt="Pensionsversicherungsanstalt (PVA)" height="68" width="104">
                                </a>
                            </figure>


                            <figure
                                style="display: table-cell; padding: 0 2px; text-align: center; vertical-align: middle;">
                                <a href="https://www.svs.at/" target="_blank"
                                   title="Sozialversicherungsanstalt der Selbständigen (SVS)" rel="noopener">
                                    <img
                                        ngSrc="assets/images/HB-SVS_logo.jpg"
                                        alt="Sozialversicherungsanstalt der Selbständigen (SVS)" height="56" width="100">
                                </a>
                            </figure>

                            <figure
                                style="display: table-cell; padding: 0 2px; text-align: center; vertical-align: middle;">
                                <a href="https://www.aerztekammer.at/" target="_blank"
                                   title="Österreichische Ärztekammer (ÖÄK)" rel="noopener">
                                    <img
                                        ngSrc="assets/images/small_oak.jpg"
                                        alt="Österreichische Ärztekammer (ÖÄK)" height="45" width="91">
                                </a>
                            </figure>

                            <figure
                                style="display: table-cell; padding: 0 2px; text-align: center; vertical-align: middle;">
                                <a href="https://www.oegkv.at/" target="_blank"
                                   title="Österreichischer Gesundheits- und Krankenpflegeverband (ÖGKV)" rel="noopener">
                                    <img
                                        ngSrc="assets/images/small_oegkv.jpg"
                                        alt="Österreichischer Gesundheits- und Krankenpflegeverband (ÖGKV)" height="60"
                                        width="100">
                                </a>
                            </figure>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-3">
                <div class="footer-widget">
                    <ul class="footer-media-icons">


                    </ul>
                </div>
            </div>
        </div> <!-- /.row -->

        <div class="bottom-footer">
            <div class="row">
                <div class="col-md-5">
                    © Copyright 2026
                </div> <!-- /.col-md-5 -->
                <div class="col-md-7">
                </div> <!-- /.col-md-7 -->
            </div> <!-- /.row -->
        </div> <!-- /.bottom-footer -->

    </div> <!-- /.container -->
</footer> <!-- /.site-footer -->
